import React from 'react';
import { cn } from '../utils/cn';

export interface BentoCardProps extends React.HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  elevation?: 'low' | 'standard' | 'high';
  glowBorderColor?: string;
}

export const BentoCard: React.FC<BentoCardProps> = ({
  children,
  className,
  elevation = 'standard',
  glowBorderColor,
  style,
  ...props
}) => {
  const elevationClasses = {
    low: 'bg-[#161616] border-[rgba(255,255,255,0.05)]',
    standard: 'bg-[#1A1A1A] border-[rgba(255,255,255,0.08)] hover:bg-[#202020] transition-colors duration-150',
    high: 'bg-[#201F1F] border-[rgba(255,255,255,0.12)] shadow-[0_8px_32px_rgba(0,0,0,0.6)]',
  }[elevation];

  const customStyle: React.CSSProperties = {
    ...style,
    ...(glowBorderColor ? { borderColor: glowBorderColor, boxShadow: `0 0 12px ${glowBorderColor}` } : {}),
  };

  return (
    <div
      className={cn(
        'rounded-[24px] border p-6 text-[#E5E2E1] relative overflow-hidden',
        elevationClasses,
        className
      )}
      style={customStyle}
      {...props}
    >
      {children}
    </div>
  );
};
